import axios from "axios";
import toast from "react-hot-toast";
import { API_URL } from "./constants";

console.log('Axios baseURL:', API_URL);

const Axios = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

Axios.interceptors.request.use(
  function (config) {
    // Always add Authorization if token exists
    config.headers = {
      ...config.headers,
    };

    // Auto-detect FormData
    if (config.data instanceof FormData) {
      // Let browser set the proper multipart/form-data with boundary
      delete config.headers["Content-Type"];
    } else {
      // Default for normal requests
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

Axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    try {
      if (error && error.response && error.response.status === 401) {
        toast.dismiss();
        toast.error("Unable to process your request right now.");
      }
    } catch (e) {
      console.error("Error accessing localStorage:", e);
      // Optional: still redirect if something's wrong with storage
    }

    return Promise.reject(error);
  }
);


export default Axios;
